import { CookieShape } from './../ts/Definitions';
import { Cookies as ReactCookie } from 'react-cookie';


const cookieOptions = { path: '/', maxAge: 31536000 };

export const COOKIE_KEY_POSITION_TICKS = 'positionTimerTicks';
export const COOKIE_KEY_SELECTED_SESSION_USER_ID = 'SELECTED_SESSION';

// cookie management
export default class Cookies {
  cookies: ReactCookie = {} as ReactCookie;
  callback: (() => void) | undefined = undefined;
  password = '';
  username = '';
  userid = '';
  email = '';
  acceptTerms = false;
  autoLogon = false;
  voteItems: string[] = [];

  initialise = (cookies: ReactCookie, callback: (() => void)) => {
    this.cookies = cookies;
    this.callback = callback;
    this.password = cookies.get('password');
    this.username = cookies.get('username');
    this.userid = cookies.get('userid');
    this.email = cookies.get('email');
    this.acceptTerms = cookies.get('acceptTerms') === 'true';
    this.autoLogon = cookies.get('autoLogon') === 'true';
    try {
      this.voteItems = cookies.get('voteItems') as [];
    } catch (e) {
      console.log(e);
      this.voteItems = [];
    }
  }

  setUser = (password: string, username: string, userid: string, acceptTerms: boolean | undefined, autoLogon: boolean | undefined): void => {
    if (password === this.password
      && username === this.username
      && userid === this.userid
      && acceptTerms === this.acceptTerms
      && autoLogon === this.autoLogon) return;
    this.password = password;
    this.username = username;
    this.userid = userid;
    this.cookies.set('password', password, cookieOptions);
    this.cookies.set('username', username, cookieOptions);
    this.cookies.set('userid', userid, cookieOptions);
    this.cookies.set('acceptTerms', acceptTerms, cookieOptions);
    this.cookies.set('autoLogon', autoLogon, cookieOptions);
    if (this.callback) this.callback();
  }

  setVoteItems = (voteItems: string[]) => {
    this.voteItems = voteItems;
    this.cookies.set('voteItems', JSON.stringify(voteItems));
  }

  clearState = (name: string): void => {
    this.cookies.remove(name);
    this.cookies.remove(name, cookieOptions)
    if (this.callback) this.callback();
  }

  setState = (name: string, value: string): void => {
    this.cookies.set(name, value);
    this.cookies.set(name, value, cookieOptions)
    if (this.callback) this.callback();
  }

  getState = (name: string): string => {
    return this.cookies.get(name);
  }

  getUserCredentials = (): CookieShape => {
    return { password: this.password, username: this.username, userid: this.userid, tempEmail: this.email, autoLogon: this.autoLogon, acceptTerms: this.acceptTerms };
  }
}
